<template>
  <div>
    <a-card v-if="queryList" :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" :form="form" >
          <a-row :gutter="24">
            <a-col :span="6" >
              <a-form-item style="margin-left: 42px;" label="师傅姓名">
                <a-input v-model="queryParam.userName" ></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="6" >
              <a-form-item style="margin-left: 13px"  label="联系方式">
                <a-input v-model="queryParam.phonenumber" ></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="6" >
              <a-form-item label="师傅类型" style="margin-left: 13px"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="queryParam.workerType">
                  <a-select-option :title="type.label" v-for="type in restaurantTypes" :key="type.code">{{type.label}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6" >
              <a-form-item label="服务类型" style="margin-left:42px"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="queryParam.installType">
                  <a-select-option :title="type.label" v-for="type in restaurantTypes1" :key="type.code">{{type.label}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-row>
                <a-form-item style="margin-left: 42px;"  label="服务区域" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-col :span="8">
                    <a-select v-decorator="['serviceProvinceId']" @change="haveProvince1">
                      <a-select-option  :title="type.provinceName" v-for="type in data1" :key="type.provinceCode">{{type.provinceName}}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :span="8">
                    <a-select v-decorator="['serviceCityId']" @change="haveProvince2">
                      <a-select-option :title="type.cityName" v-for="type in data2" :key="type.cityCode">{{type.cityName}}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :span="8">
                    <a-select v-decorator="['serviceDistrictId']" >
                      <a-select-option :title="type.areaName" v-for="type in data3" :key="type.areaCode">{{type.areaName}}</a-select-option>
                    </a-select>
                  </a-col>
                </a-form-item>
              </a-row>
            </a-col>
            <a-col :span="6">
              <a-form-item label="师傅等级" style="margin-left: 13px"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="queryParam.techLevel">
                  <a-select-option :title="type.label" v-for="type in restaurantTypes2" :key="type.code">{{type.label}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="接单方式" style="margin-left:42px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="queryParam.receiptType">
                  <a-select-option :title="type.label" v-for="type in restaurantTypes3" :key="type.code">{{type.label}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="6">
              <a-row>
                <a-form-item style="margin-left: 42px;"  label="师傅得分" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-col :span="11">
                    <a-input  v-model="queryParam.userStartScore" />
                  </a-col>
                  <a-col :span="2">
                    <span style="margin:0 5px">-</span>
                  </a-col>
                  <a-col :span="11">
                    <a-input  v-model="queryParam.userEndScore" />
                  </a-col>
                </a-form-item>
              </a-row>

            </a-col>
            <a-col :span="6">
              <a-form-item style="margin-left: 13px" label="师傅标签" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                <a-select v-model="queryParam.masterLabel">
                  <a-select-option :title="type.installLabelName" v-for="type in data" :key="type.installLabelId">{{type.installLabelName}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="提现周期" style="margin-left: 13px"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="queryParam.cashCycle">
                  <a-select-option :title="type.label" v-for="type in restaurantTypes4" :key="type.code">{{type.label}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="加入黑名单时间">
                <a-range-picker
                  v-model="queryParam2.time2"
                  :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')] }"
                  format="YYYY-MM-DD HH:mm:ss"
                  :placeholder="['开始时间', '结束时间']"
                  @ok="onOk"
                  style="width: 100%"
                  @change="onChange"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-item label="加入黑名单原因" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="queryParam.blackReason" ></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="渠道负责人" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select show-search :filter-option="filterOption" v-model="queryParam.masterProvince">
                  <a-select-option :title="type.userName" v-for="type in ChannelDirector" :key="type.userId">{{type.userName}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="师傅负责人" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select show-search :filter-option="filterOption" v-model="queryParam.masterLeading">
                  <a-select-option :title="type.userName"  v-for="type in ChannelDirector" :key="type.userId">{{type.userName}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="提现方式"  style="margin-left:42px"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="queryParam.cashStatus">
                  <a-select-option :title="type.label"  v-for="type in restaurantTypes5" :key="type.code">{{type.label}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24" v-if="isShow == 1">
            <a-col :span="6">
              <a-row>
                <a-form-item style="margin-left:13px;"  label="近30天投诉率"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-col :span="11">
                    <a-input  v-model="queryParam.complaintRateBegin" />
                  </a-col>
                  <a-col :span="2">
                    <span style="margin:0 5px">-</span>
                  </a-col>
                  <a-col :span="11">
                    <a-input  v-model="queryParam.complaintRateEnd" />
                  </a-col>
                </a-form-item>
              </a-row>
            </a-col>
          </a-row>
          <span class="table-page-search-submitButtons">
          <a-row type="flex" justify="space-between">
            <a-col :span="3" :offset="11">
              <span v-if="isShow == 0" style="cursor:pointer" @click="getMore"><a-icon type="down-circle" theme="twoTone" style="fontSize:24px"/> </span>
              <!--<a-divider type="vertical" />-->
              <span v-if="isShow == 1" style="cursor:pointer" @click="hiddenMore"><a-icon type="up-circle" theme="twoTone" style="fontSize:24px"/></span>
            </a-col>
            <a-col :span="6" style="text-align: right">
              <a-button type="primary" htmlType="submit" @click="Update()">查询</a-button>
              <a-button style="margin-left: 8px" @click="clearValues">清空</a-button>
            </a-col>
          </a-row>
        </span>
        </a-form>
      </div>
      <s-table
        size="default"
        ref="table"
        rowKey="id"
        :columns="columns"
        :data="loadData"
        bordered
        :scroll="{ x:800 }"
      >
      <span slot="action" slot-scope="text, record">
        <!--详情跳转师傅详情-->
        <a v-if="detailsEnable" @click="details(record)">详情</a>
        <a-divider type="vertical"/>
        <!--服务区域跳转师傅服务区域-->
        <a  @click="ServiceArea(record)">服务区域</a>
        <a-divider type="vertical"/>
        <!--查看团队跳转团队列表-->
        <a v-if="record.workerTypeName=='服务商'" @click="Viewteam(record)">查看团队</a>
        <a-divider v-if="record.workerTypeName=='服务商'" type="vertical"/>
        <a  @click="recovery(record.userId)">恢复</a>
        </span>
      </s-table>
      <masterlist-edit ref="modal" ></masterlist-edit>
      <view-editing ref="modal2"></view-editing>
    </a-card>
    <no-authority v-else></no-authority>
  </div>
</template>
<script>
  import moment from 'moment';
  import { STable } from '@/components'
  import {getDictMap} from "../../utils/dict"
  import { checkPermission } from '@/utils/permissions'
  import { getSelectAllProvince,getelectCityName,getelectAreaName } from '@/api/master/MasterList'
  import { queryMasterBlack,recoverMaster} from '@/api/master/MasterBlacklist'
  import MasterlistEdit from './modules/MasterlistEdit.vue'
  import ViewEditing from './modules/ViewEditing.vue'
  import NoAuthority from '../enterprise/NoAuthority'
  import { queryMaster,selectALLInstallLabel,addMaster } from '@/api/master/MasterList'
  import { findByDeptId } from '@/api/enterprise/user'
  import {selectFindAll} from '@/api/enterprise/enterprise'

  export default {
    name: 'TableList',
    components: {
      STable,
      MasterlistEdit,
      ViewEditing,
      NoAuthority
    },
    data () {
      return {
        detailsEnable: checkPermission('master:MasterBlacklist:view:details'),
        queryList: checkPermission('master:MasterBlacklist:query:list'),
        form: this.$form.createForm(this),
        mdl: {},
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},
        queryParam2:{},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        isShow:0,
        data:[],
        data1:[],
        data2:[],
        data3:[],
        restaurantTypes:[],
        restaurantTypes1:[],
        restaurantTypes2:[],
        restaurantTypes3:[],
        restaurantTypes4:[],
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: 'rowNum',
            align:'center',
          },
          {
            title: '操作',
            dataIndex: 'action',
            width:'20px',
            scopedSlots: { customRender: 'action'},
          }, {
            title: '师傅姓名',
            dataIndex: 'userName',
            align:'center',
          }, {
            title: '联系方式',
            dataIndex: 'phonenumber',
            align:'center',
          }, {
            title: '师傅类型',
            dataIndex: 'workerTypeName',
            align:'center',

          }, {
            title: '师傅等级',
            dataIndex: 'techLevelName',
            align:'center',
          }, {
            title: '服务类别',
            dataIndex: 'installName',
            align:'center',
          }, {
            title: '师傅得分',
            dataIndex: 'userScore',
            align:'center',
          }, {
            title: '接单模式',
            dataIndex: 'receiptTypeName',
            align:'center',
          }, {
            title: '标签',
            dataIndex: 'masterLabelName',
            align:'center',
          }, {
            title: '提现周期',
            dataIndex: 'cashCycleName',
            align:'center',
          }, {
            title: '师傅负责人',
            dataIndex: 'masterLeadingName',
            align:'center',
          }, {
            title: '提现方式',
            dataIndex: 'cashStatusName',
            align:'center',
          }, {
            title: '近30天投诉率',
            dataIndex: 'complaintRateRecent',
            align:'center',
          }, {
            title: '接单量',
            dataIndex: 'receiveOrder',
            align:'center',
          }, {
            title: '销单量',
            dataIndex: 'writeOrder',
            align:'center',
          }, {
            title: '师傅负责人',
            dataIndex: 'masterLeadingName',
            align:'center',
          }, {
            title: '渠道负责人',
            dataIndex: 'masterProvinceName',
            align:'center',
          }, {
            title: '审核时间',
            dataIndex: 'auditTime',
            align:'center',
          }, {
            title: '审核人',
            dataIndex: 'auditByName',
            align:'center',
          }, {
            title: '注册情况',
            dataIndex: 'status',
            align:'center',
          }, {
            title: '注册时间',
            dataIndex: 'createTime',
            align:'center',
          }, {
            title: '注册人',
            dataIndex: 'createByName',
            align:'center',
          }, {
            title: '加入黑名单时间',
            dataIndex: 'blackTime',
            align:'center',
          }, {
            title: '拉黑原因',
            dataIndex: 'blackReason',
            align:'center',
          }
        ],
        ChannelDirector:[],
        // 加载数据方法 必须为 Promise 对象
        // loadData: parameter => {
        //   return queryMasterContract(Object.assign(parameter, this.queryParam))
        // },
        loadData: parameter => {
          return queryMasterBlack(Object.assign(parameter, this.queryParam))
        },
      }
    },
    filters: {},
    async created () {
        document.body.addEventListener('keyup', e => {
        if (e.keyCode == 13) {
          this.Update()
        }
      })
      findByDeptId('106').then(res=>{
        this.ChannelDirector=res
      })

      selectFindAll({dictTypes:'install_type,worker_type,tech_level,receipt_type,cash_cycle,cash_status'}).then(res=>{

      this.restaurantTypes = [];
      this.restaurantTypes1 = [];
      this.restaurantTypes2 = [];
      this.restaurantTypes3 = [];
      this.restaurantTypes4 = [];
      this.restaurantTypes5 = [];

        this.restaurantOperTypeMap = res.worker_type
        this.restaurantOperTypeMap1 = res.install_type
        this.restaurantOperTypeMap2 = res.tech_level
        this.restaurantOperTypeMap3 =res.receipt_type
        this.restaurantOperTypeMap4 = res.cash_cycle
        this.restaurantOperTypeMap5 = res.cash_status
      this.restaurantOperTypeMap.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes.push({code: value.dictValue, label: value.dictLabel})
      })
      this.restaurantOperTypeMap1.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes1.push({code: value.dictValue, label: value.dictLabel})
      })
      this.restaurantOperTypeMap2.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes2.push({code: value.dictValue, label: value.dictLabel})
      })
      this.restaurantOperTypeMap3.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes3.push({code: value.dictValue, label: value.dictLabel})
      })
      this.restaurantOperTypeMap4.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes4.push({code: value.dictValue, label: value.dictLabel})
      })
      this.restaurantOperTypeMap5.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes5.push({code: value.dictValue, label: value.dictLabel})
      })

      })
      // 标签code: value.dictValue, label: value.dictLabel
      selectALLInstallLabel().then(res=>{
        console.log(res.data,'师傅标签')
        this.data = res.data
      })
      // 省
      getSelectAllProvince().then(res=>{
        // console.log(res)
        this.data1=res.rows
      })
    },
    destroyed () {
      document.body.removeEventListener('keyup', e => {})
    },
    methods: {
      moment,
      // 更多、隐藏
      getMore(){
        this.isShow = 1
      },
      hiddenMore(){
        this.isShow = 0
      },
      //查询
     async Update(){
        this.queryParam.serviceCityId=this.form.getFieldValue('serviceCityId')
        this.queryParam.serviceDistrictId=this.form.getFieldValue('serviceDistrictId')
        this.queryParam.serviceProvinceId=this.form.getFieldValue('serviceProvinceId')

        this.$refs.table.refresh(true)
      },
      filterOption(input, option) {
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
      details(record){//详情
        this.$refs.modal.edit(record,'1')
      },
      ServiceArea(record){//服务区域
        this.$refs.modal.handleCoverage(record)
      },
      Viewteam(record){//查看团队
        this.$refs.modal2.see(record)
      },
      recovery(id){//恢复
        console.log(id)
        let that = this
          this.$confirm({
            title: '恢复',
            content: '您确定恢复？',
            okType: 'danger',
            onOk() {
              recoverMaster({ 'userId':id}).then(res => {
                console.log(res)
                if (res.code === 0) {
                  that.$message.success('恢复成功')
                  that.$refs.table.refresh()
                } else {
                  that.$message.error(res.msg)
                }
              })
            },
            onCancel() {
              console.log('Cancel');
            },
          });
      },
      clearValues(){
        this.form.resetFields()
        this.queryParam={}
        this.queryParam2={}
        this.Update()
      },
      onChange(dates, dateStrings) {
        this.queryParam.blackStartTime=dateStrings[0]
        this.queryParam.blackEndTime=dateStrings[1]
      },
      haveProvince1(e){
        this.data2=[]
        this.data3=[]
        this.form.setFieldsValue({
          'serviceCityId':'',
          'serviceDistrictId':'',
        })
        getelectCityName({provinceCode:e}).then(res=>{
          // console.log(res)
          this.data2=res.rows
        })
      },
      haveProvince2(e){
        this.data3=[]
        this.form.setFieldsValue({
          'serviceDistrictId':'',
        })
        getelectAreaName({cityCode:e}).then(res=>{
          this.data3=res.rows
        })
      },

    },
    watch: {
    }
  }
</script>

<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap; }
  /deep/ .ant-table td {  padding: 4px 16px;}
</style>
